// Auto-generated sidebar route map

const sidebarRouteMap = {
    'dashboard': { menu: 'Dashboard', submenu: null },
    'manage-branch': { menu: 'Branch Management', submenu: 'Manage Branch' },
    'manage-area': { menu: 'Branch Management', submenu: 'Manage Area' },
    'manage-delivery-point': { menu: 'Branch Management', submenu: 'Manage Delivery Point' },
    'manage-add-staff':{ menu: 'Branch Management', submenu: 'Manage Branch' },
    // 'manage-products': { menu: 'Package Management', submenu: 'Manage Products' },
    
    'manage-products': { menu: 'Package Management', submenu: 'Manage Products' },
    'product-category': { menu: 'Package Management', submenu: 'Manage Products' },
    
    // 'manage-packages': { menu: 'Package Management', submenu: 'Manage Packages' },

     'manage-packages': { menu: 'Package Management', submenu: 'Manage Packages' },
    'package-period': { menu: 'Package Management', submenu: 'Manage Packages' },
    
    'manage-lead': { menu: 'Lead Management', submenu: 'Manage Lead' },
    'manage-coupon': { menu: 'Lead Management', submenu: 'Manage Coupon' },
    "redeem-points": { menu: 'Lead Management', submenu: 'Manage Coupon' },
    'manage-subscribers': { menu: 'Subscriber Management', submenu: null },
    'manage-subscriptions': { menu: 'Subscription Management', submenu: 'Manage Subscription' },
    'manage-hold': { menu: 'Subscription Management', submenu: 'Manage Hold' },
    'manage-drop': { menu: 'Subscription Management', submenu: 'Manage Drop' },
    'manage-payments': { menu: 'Payments Management', submenu: 'Manage Payments' },
    'payments-management': { menu: 'Payments Management', submenu: 'Manage Payments' },
    'manage-refund': { menu: 'Payments Management', submenu: 'Manage Refund' },
    
    // 'manage-items': { menu: 'Package Management', submenu: 'Manage Items' },
    // 'item-schedule': { menu: 'Package Management', submenu: 'Manage Items' },
    // 'item-sub-category': { menu: 'Package Management', submenu: 'Manage Items' },
    // 'item-category': { menu: 'Package Management', submenu: 'Manage Items' },
    
    'manage-items': { menu: 'Package Management', submenu: 'Manage Items' },    
    'item-category': { menu: 'Package Management', submenu: 'Manage Items' },
    'item-sub-category': { menu: 'Package Management', submenu: 'Manage Items' },
    'item-schedule': { menu: 'Package Management', submenu: 'Manage Items' },
    
    // 'manage-product-quantity': { menu: 'Package Management', submenu: 'Manage Product Quantity' },
    
    'manage-product-quantity': { menu: 'Package Management', submenu: 'Manage Product Quantity'},
    
    
    'menu-maker': { menu: 'Production Management', submenu: 'Menu Maker' },
    'manage-daily-orders': { menu: 'Production Management', submenu: 'Manage Daily Orders' },
    'manage-work-assignment': { menu: 'Production Management', submenu: 'Manage Work Assignment' },
    'manage-quality-analysis': { menu: 'Production Management', submenu: 'Manage Quality Analysis' },
    'manage-wastage': { menu: 'Production Management', submenu: 'Manage Wastage' },
    'manage-production-costing': { menu: 'Production Management', submenu: 'Manage Production Costing' },
    'manage-rawmaterials': { menu: 'Stock Management', submenu: 'Manage Raw Materials' },
    'manage-vendors': { menu: 'Purchase Management', submenu: 'Manage Vendors' },
    'manage-purchase': { menu: 'Purchase Management', submenu: 'Manage Purchase' },
    // 'manage-stocks': { menu: 'Purchase Management', submenu: 'Manage Stocks' },
    'manage-pricebook': { menu: 'Purchase Management', submenu: 'Manage Pricebook' },
    'stock-consumption': { menu: 'Purchase Management', submenu: 'Stock Consumption' },
    'manage-tripsheet': { menu: 'Delivery Management', submenu: 'Manage Tripsheets' },
    'manage-delivery': { menu: 'Delivery Management', submenu: 'Manage Delivery' },
    'manage-tracking': { menu: 'Delivery Management', submenu: 'Manage Tracking' },
    'manage-complaints': { menu: 'Complaints Management', submenu: 'Manage Complaints' },
    // 'manage-corporates': { menu: 'Corp Order Management', submenu: 'Manage Corporate Costing' }, // Shared route
    // 'manage-catering-order': { menu: 'Catering Management', submenu: 'Manage Catering Order' },
    'manage-vehicles': { menu: 'Maintenance Management', submenu: 'Manage Vehicles' },
    'manage-forecast-metrics': { menu: 'Metrics Management', submenu: 'Forecast Metrics' },

    'manage-staff': { menu: 'HR Management', submenu: 'Manage Staff' },
    'manage-attendance': { menu: 'HR Management', submenu: 'Manage Attendance' },
    'manage-payouts': { menu: 'HR Management', submenu: 'Manage Payouts' },
    'daily-accounts': { menu: 'Accounts Management', submenu: 'Daily Accounts' },
    'profit-loss': { menu: 'Accounts Management', submenu: 'Profit & Loss' },
    'trial-balance': { menu: 'Accounts Management', submenu: 'Trial Balance' },
    
    'settings': { menu: 'Settings', submenu: null },
    "function-type": { menu: 'Settings', submenu: 'null' },
    "catering-type": { menu: 'Settings', submenu: 'null' }, 

    // Common nested extensions
    'add-branch': { menu: 'Branch Management', submenu: 'Manage Branch' },
    'edit-branch': { menu: 'Branch Management', submenu: 'Manage Branch' },

    'lead-to-subscription': { menu: 'Lead Management', submenu: 'Manage Lead' },

    'view-subscribers': { menu: 'Subscriber Management', submenu: 'null' },
    'new-subscriptions': { menu: 'Subscriber Management', submenu: 'null' },

    "view-items": { menu: 'Production Management', submenu: 'Manage Items' },

    "add-vendors": { menu: 'Purchase Management', submenu: 'Manage Vendors' },
    "edit-vendors": { menu: 'Purchase Management', submenu: 'Manage Vendors' },
    "view-vendors": { menu: 'Purchase Management', submenu: 'Manage Vendors' },

    "add-purchase": { menu: 'Purchase Management', submenu: 'Manage Purchase' },
    "edit-purchase": { menu: 'Purchase Management', submenu: 'Manage Purchase' },
    "view-purchase": { menu: 'Purchase Management', submenu: 'Manage Purchase' },
    'auto-purchase': { menu: 'Purchase Management', submenu: 'Manage Purchase' },

    "stocks-checklist": { menu: 'Stock Management', submenu: 'Manage Stocks' },
    

    "view-vehicle": { menu: 'Maintenance Management', submenu: 'Manage Vehicles' },
    "add-vehicle": { menu: 'Maintenance Management', submenu: 'Manage Vehicles' },
    "edit-vehicle": { menu: 'Maintenance Management', submenu: 'Manage Vehicles' },

    "view-staff": { menu: 'HR Management', submenu: 'Manage Staff' },
    "add-staff": { menu: 'HR Management', submenu: 'Manage Staff' },
    "edit-staff": { menu: 'HR Management', submenu: 'Manage Staff' },

    "add-attendance": { menu: 'HR Management', submenu: 'Manage Attendance' },

    'users-manage': { menu: 'Users Management', submenu: 'Manage Users' },
    'manage-users-role': { menu: 'Users Management', submenu: 'Manage User Role' },
    "add-users": { menu: 'Users Management', submenu: 'Manage User Role' },
    "edit-users": { menu: 'Users Management', submenu: 'Manage User Role' },
    "view-users": { menu: 'Users Management', submenu: 'Manage User Role' },

    "general-settings": { menu: 'Settings', submenu: 'null' },
    "lead-type": { menu: 'Settings', submenu: 'null' },
    "lead-source": { menu: 'Settings', submenu: 'null' },
    "lead-status": { menu: 'Settings', submenu: 'null' },
    "drop-reason": { menu: 'Settings', submenu: 'null' },
    "preparation-category": { menu: 'Settings', submenu: 'null' },
    "duration": { menu: 'Settings', submenu: 'null' },
    "temperature": { menu: 'Settings', submenu: 'null' },
    "item-property-type": { menu: 'Settings', submenu: 'null' },
    "item-property": { menu: 'Settings', submenu: 'null' },
    "payment-mode": { menu: 'Settings', submenu: 'null' },
    "raw-material-category": { menu: 'Settings', submenu: 'null' },
    "unit-category": { menu: 'Settings', submenu: 'null' },
    "units": { menu: 'Settings', submenu: 'null' },
    "vendor-category": { menu: 'Settings', submenu: 'null' },
    "business-type": { menu: 'Settings', submenu: 'null' },
    "vehicle-category": { menu: 'Settings', submenu: 'null' },
    "service-type": { menu: 'Settings', submenu: 'null' },
    "document-type": { menu: 'Settings', submenu: 'null' },
    "department": { menu: 'Settings', submenu: 'null' },
    "shift-time": { menu: 'Settings', submenu: 'null' },
    "job-role": { menu: 'Settings', submenu: 'null' },
    "leave-type": { menu: 'Settings', submenu: 'null' },
    "complaint-type": { menu: 'Settings', submenu: 'null' },
    "ledger": { menu: 'Settings', submenu: 'null' },
    "sub-ledger": { menu: 'Settings', submenu: 'null' },
    "menu": { menu: 'Settings', submenu: 'null' },
    "spam-reason": { menu: 'Settings', submenu: 'null' },
    "dead-reason": { menu: 'Settings', submenu: 'null' },
    "internal-call": { menu: 'Settings', submenu: 'null' },
    'manage-appointment': { menu: 'Lead Management', submenu: 'Manage Appointment' },
    'manage-followup': { menu: 'Lead Management', submenu: 'Manage Followup' },
     'manage-closed-followup': { menu: 'Lead Management', submenu: 'Manage Followup' },
    'manage-reschedule-followup': { menu: 'Lead Management', submenu: 'Manage Followup' },
    'manage-unfollowup': { menu: 'Lead Management', submenu: 'Manage Followup' },
    'manage-calls': { menu: 'Lead Management', submenu: 'Manage Calls' },
    'manage-calendar': { menu: 'Lead Management', submenu: 'Lead Calendar' },
    'manage-source': { menu: 'Lead Management', submenu: 'Lead Source' },
    'manage-cloud-call' : { menu: 'Lead Management', submenu: 'Manage Cloud Call' },
    'manage-spam-lead': { menu: 'Lead Management', submenu: 'Manage Lead' },
    'manage-dead-lead': { menu: 'Lead Management', submenu: 'Manage Lead' },
    'manage-internal-call': { menu: 'Lead Management', submenu: 'Manage Lead' },
    'manage-today-followup': { menu: 'Lead Management', submenu: 'Manage Lead' },
    //  'manage-corporate': { menu: 'Corporate Management', submenu: 'Manage Corporate' },
     
    'manage-order': { menu: 'Subscription Management', submenu: 'Manage Order' },
    'add-subscriptions': { menu: 'Subscription Management', submenu: 'Manage Order' },
    'view-subscriber-details': { menu: 'Subscription Management', submenu: 'Manage Order' },

    'team-lead': { menu: 'Team Management', submenu: 'Team Lead' },
    'team-followup': { menu: 'Team Management', submenu: 'Team Followup' },
    'team-appointment': { menu: 'Team Management', submenu: 'Team Appointment' },
    'team-call': { menu: 'Team Management', submenu: 'Team Call' },
    'team-promise': { menu: 'Team Management', submenu: 'Team Promise' },
    'team-monthly-promise': { menu: 'Team Management', submenu: 'Team Promise' },
    
    'manage-catering-order': { menu: 'Catering Management', submenu: 'Manage Catering Order' },
    'catering-order-edit': { menu: 'Catering Management', submenu: 'Manage Catering Order' },
    'catering-order-confirm': { menu: 'Catering Management', submenu: 'Manage Catering Order' },
    'catering-orrder-view': { menu: 'Catering Management', submenu: 'Manage Catering Order' },
    
    'catering-payment': { menu: 'Catering Management', submenu: 'Manage Catering Payment' },
    'catering-delivery': { menu: 'Catering Management', submenu: 'Manage Catering Delivery' },
    
    'manage-catering-customer': { menu: 'Catering Management', submenu: 'Manage Customer' },
    'view-catering-customer': { menu: 'Catering Management', submenu: 'Manage Customer' },
    
    'catering-order': { menu: 'Catering Management', submenu: 'Manage Customer' },
    'manage-corporate-order': { menu: 'Corp Order Management', submenu: 'Manage Corporate Order' },
    'corporate-order-edit': { menu: 'Corp Order Management', submenu: 'Manage Corporate Order' },
    'corporate-order-confirm': { menu: 'Corp Order Management', submenu: 'Manage Corporate Order' },
    'corporate-orrder-view': { menu: 'Corp Order Management', submenu: 'Manage Corporate Order' },
    'manage-corporate-customer': { menu: 'Corp Order Management', submenu: 'Manage Corporate Customer' },
    'corporate-order': { menu: 'Corp Order Management', submenu: 'Manage Corporate Order' },
    'corporate-customer-view': { menu: 'Corp Order Management', submenu: 'Manage Corporate Customer' },
    'corporate-payment': { menu: 'Corp Order Management', submenu: 'Manage Corporate Payment' },
    'corporate-delivery': { menu: 'Corp Order Management', submenu: 'Manage Corporate Delivery' },
    
    'manage-stocks': { menu: 'Stock Management', submenu: 'Manage Storage' },
    'manage-stockin': { menu: 'Stock Management', submenu: 'Manage Stocks-In' },
    'manage-stockout': { menu: 'Stock Management', submenu: 'Manage Stocks-Out' },
    'manage-weeklyConsumption': { menu: 'Stock Management', submenu: 'Manage Kitchen Material' },
    'payments-history': { menu: 'Payments Management', submenu: 'Manage History' },
    'manage-machinery': { menu: 'Maintenance Management', submenu: 'Manage Machinery' },
    
    'cronjob-monitor': { menu: 'Monitoring Tools', submenu: 'Cronjob Monitor' },
    'call-log-monitor': { menu: 'Monitoring Tools', submenu: 'Call Log' }, 
    'manage-userlogs': { menu: 'Monitoring Tools', submenu: 'User Log' },
    'manage-maintenancemode': { menu: 'Monitoring Tools', submenu: 'Maintenance Mode' },
    'manage-maintenance': { menu: 'Maintenance Management', submenu: 'Manage Maintenance' },
        'kpi-manage-target': { menu: 'KPI Management', submenu: 'Manage Target' },
            'manage-forecast-metrics': { menu: 'Metrics Management', submenu: 'Forecast Metrics' },
            
            //Cookware catageory
            
            "cookware_category": { menu: 'Settings', submenu: 'null' },
    "cookware_material": { menu: 'Settings', submenu: 'null' },
    "cookware_subcategory": { menu: 'Settings', submenu: 'null' },
    "cookware": { menu: 'Settings', submenu: 'null' },
    "mechinery-category": { menu: 'Settings', submenu: 'null' },
};

export default sidebarRouteMap;
